<template>
  <reflection-form :reflection="reflection" :isEdit="true"></reflection-form>
</template>

<script>
import { ReflectionsAPI } from "@/lib/api"
import ReflectionForm from "@/components/reflections/ReflectionForm"
import EventBus from "@/lib/eventBus"

export default {
  components: { ReflectionForm },
  data: function() {
    return {
      reflection: {}
    }
  },
  methods: {
    GetReflection: function(id) {
      ReflectionsAPI.get(id).then(response => {
        this.reflection = response
      })
    },
    SaveReflection: function(reflection) {
      ReflectionsAPI.update(reflection.id, reflection).then(() => {
        this.$toasted.clear()
        this.$toasted.success("Update Successful", {
          icon: "check",
          position: "top-center",
          duration: 2200,
          fullWidth: false,
          theme: "bubble"
        })
        this.$router.push({
          name: "reflectionsView",
          params: { id: reflection.id }
        })
      })
    }
  },
  created() {
    this.GetReflection(this.$route.params.id)
    EventBus.$on("reflection:update", reflection => {
      this.SaveReflection(reflection)
    })
  },
  beforeDestroy() {
    EventBus.$off("reflection:update")
  }
}
</script>

<style lang="css" scoped></style>
